import React from "react";
import { useNavigate } from "react-router-dom";
import "./style.css";

import informationTechnology from "../../../assets/infoandtech.png";
import forecast from "../../../assets/forecast.png";
import accounting from "../../../assets/accounting.png";
import procureToPay from "../../../assets/procurePay.png";
import orderToCash from "../../../assets/orderToCash.png";
import machine from "../../../assets/packing-machine.png";

const AnnomolyDetection = () => {
  const navigate = useNavigate();

  const cardData = [
    {
      title: "Procure To Pay",
      image: procureToPay,
      onClick: () => navigate(`/entity-controller/insights/eda/eda-list`),
    },
    {
      title: "Forecast to Deploy",
      image: forecast,
    },
    {
      title: "Information Technology",
      image: informationTechnology,
      onClick: () => navigate("/entity-controller/insights/eda/IT"),
    },
    {
      title: "Order to Cash",
      image: orderToCash,
    },
    {
      title: "General Acc. & Reporting",
      image: accounting,
      onClick: () => navigate("/entity-controller/insights/eda/Accounting"),
    },
    {
      title: "Property Plant & Equipment",
      image: machine,
    },
  ];

  return (
    <div className="eda-container">
      {cardData.map((card, index) => (
        <div key={index} className="eda-card" onClick={card.onClick}>
          <div className="eda-card-title">{card.title}</div>

          <div className="eda-card-image">
            <img src={card.image} alt={card.title} />
          </div>

          <div className="eda-card-footer">Click To View</div>
        </div>
      ))}
    </div>
  );
};

export default AnnomolyDetection;
